<template>
  <div>
    <Card class="p-no-shadow-app">
      <template #title>Informação do Pat</template>
      <template #content>
        <div class="p-grid">
          <div class="p-col-12 p-md-4">
            <p><strong>PAT:</strong> {{ patInfo?.id }}</p>
            <p><strong>Estado:</strong> {{ patInfo?.status }}</p>
            <p v-if="can('seeInternalStatesPats')"><strong>Estado Interno:</strong> {{ patInfo?.internalStateName }}</p>
            <p><strong>Status Público:</strong> {{ patInfo?.publicStatus }}</p>
            <p><strong>Tipo de PAT:</strong> {{ patInfo?.type }}</p>
            <p><strong>Departamento:</strong> {{ patInfo?.department }}</p>
            <p>
              <strong>Data do PAT:</strong> {{ patInfo?.date }} {{ patInfo?.time }}
            </p>
            <p>
              <strong>Data e hora de atribuição:</strong> {{ patInfo?.interventionDate }} {{ patInfo?.interventionTime }}
            </p>
            <p><strong>V/ Ref:</strong> {{ patInfo?.externalRef }}</p>
            <p><strong>Ref. fabricante:</strong> {{ patInfo?.manufacturerRef }}</p>
            <p><strong>Localização (nref):</strong> {{ patInfo?.nRef }}</p>
          </div>
          <div class="p-col-12 p-md-4">
            <p><strong>Situação:</strong> {{ patInfo?.situation }}</p>
            <p><strong>Resumo:</strong> {{ patInfo?.resume }}</p>
            <p><strong>Problema:</strong> {{ patInfo?.problem }}</p>
            <p><strong>Solução:</strong> {{ patInfo?.solution }}</p>
          </div>
          <div class="p-col-12 p-md-4">
            <p>
              <strong>Fechado:</strong>
              {{ patInfo?.closed == 1 ? "Sim" : "Não" }}
            </p>
            <p><strong>Fechado por:</strong> {{ patInfo?.closedBy }}</p>
            <p>
              <strong>Fechado dia:</strong> {{ patInfo?.closedDate }}
              {{ patInfo?.closedTime }}
            </p>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
export default {
  name: "PatInfo",
  props: {
    patId: {
      type: Number,
      required: true,
    },
    patInfo: {
      type: Object,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      loading: false,
    };
  },
  computed: {},
  async mounted() {},
  methods: {},
};
</script>
